import {B} from "../../../build";

const url = B.AGENT_CHAT_HOST ? new URL(B.AGENT_CHAT_HOST) : null;


function replaceWSSchema(url: URL) {

    let newSchema = url.protocol;

    if (url.protocol === 'https:') {
        newSchema = 'wss';
    } else if (url.protocol === 'http:') {
        newSchema = 'ws';
    }


    const newUrl = new URL(url);
    newUrl.protocol = newSchema + ':';
    return newUrl;
}


export const CHAT_CONFIG = {
    /**
     * API base URL, without trailing slash (e.g. https://chat.example.com/api/v1)
     */
    API_BASE_URL: !url ? '' : new URL('/api/v1', url).href,
    /**
     * WebSocket base URL, without trailing slash (e.g. wss://chat.example.com/ws)
     */
    WS_BASE_URL: !url ? '' : new URL('/ws', replaceWSSchema(url)).href,
};
